<div class="adx-widget-window-placeholder">
  <fa-icon class="adx-widget-window-placeholder-icon" [icon]="'up-right-from-square'"></fa-icon>
  <p class="adx-widget-window-placeholder-title" [title]="title">{{ title }}</p>
  <p class="adx-widget-window-placeholder-hint">{{ "APP.WIDGET_IN_WINDOW" | translate }}</p>
  <div class="adx-widget-window-placeholder-actions">
    <button mat-stroked-button data-testid="focus-window" (click)="focusRequest.emit()">
      {{ "APP.WIDGET_SHOW_WINDOW" | translate }}
    </button>
    <button mat-flat-button data-testid="bring-back" (click)="bringBackRequest.emit()">
      {{ "APP.WIDGET_BRING_BACK" | translate }}
    </button>
  </div>
</div>
